var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssosiationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.85,
    height: 22,
    rx: 1,
    fill: "#8FBBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.42578,
    y: 1,
    width: 19,
    height: 20,
    rx: 1,
    fill: "#1162A9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_7240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.42578 18L17.4258 18L17.4258 4L3.42578 4L3.42578 18Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92562 14.4999C6.2813 14.4999 5.75895 15.0223 5.75895 15.6666C5.75895 16.3109 6.2813 16.8333 6.92562 16.8333C7.56994 16.8333 8.09229 16.3109 8.09229 15.6666C8.09229 15.0223 7.56994 14.4999 6.92562 14.4999Z",
    fill: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40479 15.6667C8.40479 16.4834 7.7427 17.1455 6.92601 17.1455C6.10931 17.1455 5.44723 16.4834 5.44723 15.6667C5.44723 14.85 6.10931 14.1879 6.92601 14.1879C7.7427 14.1879 8.40479 14.85 8.40479 15.6667ZM6.92601 16.5213C7.39795 16.5213 7.78056 16.1387 7.78056 15.6667C7.78056 15.1948 7.39795 14.8122 6.92601 14.8122C6.45406 14.8122 6.07145 15.1948 6.07145 15.6667C6.07145 16.1387 6.45406 16.5213 6.92601 16.5213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3426 14.4999C12.6983 14.4999 12.1759 15.0223 12.1759 15.6666C12.1759 16.3109 12.6983 16.8333 13.3426 16.8333C13.9869 16.8333 14.5093 16.3109 14.5093 15.6666C14.5093 15.0223 13.9869 14.4999 13.3426 14.4999Z",
    fill: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8213 15.6667C14.8213 16.4834 14.1592 17.1455 13.3425 17.1455C12.5258 17.1455 11.8637 16.4834 11.8637 15.6667C11.8637 14.85 12.5258 14.1879 13.3425 14.1879C14.1592 14.1879 14.8213 14.85 14.8213 15.6667ZM13.3425 16.5213C13.8145 16.5213 14.1971 16.1387 14.1971 15.6667C14.1971 15.1948 13.8145 14.8122 13.3425 14.8122C12.8706 14.8122 12.488 15.1948 12.488 15.6667C12.488 16.1387 12.8706 16.5213 13.3425 16.5213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3426 5.16667C12.6983 5.16667 12.1759 5.68901 12.1759 6.33333C12.1759 6.97765 12.6983 7.5 13.3426 7.5C13.9869 7.5 14.5093 6.97765 14.5093 6.33333C14.5093 5.68901 13.9869 5.16667 13.3426 5.16667Z",
    fill: "#2F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8213 6.33323C14.8213 7.14993 14.1592 7.81201 13.3425 7.81201C12.5258 7.81201 11.8637 7.14993 11.8637 6.33323C11.8637 5.51654 12.5258 4.85445 13.3425 4.85445C14.1592 4.85445 14.8213 5.51654 14.8213 6.33323ZM13.3425 7.18779C13.8145 7.18779 14.1971 6.80518 14.1971 6.33323C14.1971 5.86129 13.8145 5.47868 13.3425 5.47868C12.8706 5.47868 12.488 5.86129 12.488 6.33323C12.488 6.80518 12.8706 7.18779 13.3425 7.18779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3422 14.8208C13.165 14.8208 13.0214 14.6771 13.0214 14.4999L13.0214 9.68627C12.8679 9.82802 12.6957 9.95686 12.5148 10.0748C11.8876 10.4834 11.0626 10.8209 10.2751 11.143L10.2554 11.1511C9.44461 11.4828 8.67406 11.7993 8.10331 12.1711C7.52689 12.5467 7.24642 12.9186 7.24642 13.3333L7.24642 14.4999C7.24642 14.6771 7.10276 14.8208 6.92556 14.8208C6.74835 14.8208 6.60469 14.6771 6.60469 14.4999L6.60469 13.3333C6.60469 12.5813 7.12631 12.0417 7.75301 11.6334C8.38016 11.2248 9.20523 10.8873 9.9927 10.5652L10.0124 10.5571C10.8232 10.2255 11.5937 9.90894 12.1645 9.53709C12.7409 9.16154 13.0214 8.78962 13.0214 8.37494L13.0214 7.49994C13.0214 7.32273 13.165 7.17908 13.3422 7.17908C13.5194 7.17908 13.6631 7.32273 13.6631 7.49994L13.6631 14.4999C13.6631 14.6771 13.5194 14.8208 13.3422 14.8208Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_7240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(17.4258 18) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssosiationIcon);
export default __webpack_public_path__ + "static/media/assosiation_icon.2481643549a2ff01dc6bffd7f4425a56.svg";
export { ForwardRef as ReactComponent };